import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import FiscalInvar from "./sections/FiscalInvar";
import FiscalPEV from "./sections/FiscalPEV";
import FiscalHabitation from "./sections/fiscaleHabitation";
import FiscalDependance from "./sections/FiscalDependance";
import FiscalProprio from "./sections/FiscalProprio";
import FiscalLotLocal from "./sections/FiscalLotLocal";
import toast, { Toaster } from "react-hot-toast";
import "./DetailParcelle.scss";
import axios from "axios";

const DetailFiscal = (props) => {
    let winH = window.innerHeight; //$(document).height();
    const [winHeight, setWinHeight] = useState(winH);
    const [showAdditionalButtons, setShowAdditionalButtons] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        setWinHeight(winH);
    }, [winHeight]);

    const handleBack = () => {
        // props.showTab("detailParcelle");
        // props.showDetailParcelle(true);
        props.showDetailParcelle(false);
        props.showTab("geoData");
    };

    const toggleAdditionalButtons = () => {
        setShowAdditionalButtons(!showAdditionalButtons);
     };

    const handleClick = (e) => {
        let url = "";
  
        switch (e) {
           case "standard":
              url = "standard";
              break;
           case "tiers":
              url = "tiers";
              break;
           case "parcelle":
              url = "parcelle";
              break;
           default:
              break;
        }
        fetchData(url);
     };
  
     const fetchData = (url) => {
        if (url) {
          setIsLoading(true);
      
          // Construct id_par based on props.detailKeyPar
          const id_par =
            typeof props.detailKeyPar === "string"
              ? props.detailKeyPar.substring(0, 2) + "0" + props.detailKeyPar.substring(2)
              : "";
      
          const params = {
            id_par,
            releve_type: url,
          };
      
          // Open a new window immediately to avoid popup blockers
          const openPage = window.open("", "_blank");
          if (!openPage) {
            setIsLoading(false);
            toast.error("Veuillez autoriser les pop-ups pour ce site.");
            return;
          }
      
          // Optionally, you can add some loading content to the new window
          openPage.document.write("<p>Chargement...</p>");
      
          axios
            .post("/Api/geodata/releve_prop/parcelle", params)
            .then((result) => {
              if (result.data) {
                // Replace the loading content with the actual data
                openPage.document.open();
                openPage.document.write(result.data);
                openPage.document.close();
              } else {
                toast.error("Désolé, votre requête ne produit aucun résultat !");
                openPage.close();
              }
              setIsLoading(false);
            })
            .catch((err) => {
              console.error(err);
              setIsLoading(false);
              toast.error("Désolé, une erreur s'est produite lors de votre requête !");
              openPage.close();
            });
        }
      };
    return (
        <div
            id={"detailFiscale"}
            className={"card ueThemeBackground ueColorBase border-0"}
            style={{ userSelect: "none", maxHeight: "calc(80vh - 120px) !important"}}
        >
            <div className="card-body p-0">
            <div className={"d-flex justify-content-end align-items-center back-button-container pt-3 pr-3"}>
                  <div
                     className="btn btn-sm ml-1 btn-primary d-flex align-items-center justify-content-center py-1"
                     style={{ paddingLeft: "6px", color: "#FFFFFF", cursor: "pointer" }}
                     onClick={handleBack}
                  >
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#FFFFFF"
                        className="bi bi-arrow-left-circle"
                        viewBox="0 0 16 16"
                     >
                        <path
                           fillRule="evenodd"
                           d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
                        />
                     </svg>
                     <span className="ms-2 ml-1">Retour</span>
                  </div>

               </div>
                <div
                    className="ue-detail-parcelle-section-title"
                    style={{ fontWeight: "bold", paddingLeft: "1rem" }}
                >
                    Fiche invariant {props.detailLot ? props.detailLot : null}
                </div>
                <FiscalProprio />
                <FiscalInvar />
                <FiscalHabitation />
                <FiscalDependance />
                <FiscalLotLocal />
                <FiscalPEV />
                <div style={{
                    position: "sticky",
                    bottom: 0,
                    width: "100%",

                }}>
                    <button
                        className="btn btn-block"
                        style={{
                            position: "sticky",
                            width: "97%",
                            margin: "0 auto",
                            bottom: 40,
                            backgroundColor: "#3FB9AA",
                            border: "1px solid #3FB9AA",
                            fontWeight: "bold",
                        }}
                        onClick={toggleAdditionalButtons}
                    >
                        {showAdditionalButtons && (
                            <div
                                className="additional-buttons"
                            >
                                <button
                                    className="btn"
                                    onClick={(e) => {
                                        handleClick("standard");
                                    }}
                                >
                                    Relevé de propriétaire (Standard)
                                </button>
                                <button
                                    className="btn"
                                    onClick={(e) => {
                                        handleClick("tiers");
                                    }}
                                >
                                    Relevé de propriétaire (Tiers)
                                </button>
                                <button
                                    className="btn"
                                    onClick={(e) => {
                                        handleClick("parcelle");
                                    }}
                                >
                                    Relevé de propriétaire (Parcelle)
                                </button>
                            </div>
                        )}
                        RELEVE DE PROPRIETAIRE
                    </button>
                </div>

            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        detailLot: state.LeftPanelReducer.detailLot,
        detailKeyPar: state.LeftPanelReducer.detailKeyPar,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        showDetailParcelle: (e) =>
            dispatch({
                type: "TOGGLE_SHOW_DETAIL_PARCELLE",
                data: { showDetailParcelle: e, keypar: null },
            }),
        showTab: (e) =>
            dispatch({ type: "TOGGLE_PANEL_TAB", data: { currentTab: e } }),
    };
};
export default connect(mapStateToProps, mapDispatchTProps)(DetailFiscal);
